import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Terms of Service | IntelliEats';
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-2899" data-mp="211c7g4lf1drd">
      
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2900" data-mp="13evdn9bw5iad">
        <header className="mb-12" data-id="element-2901" data-mp="18blqlnsefxrk">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-2902" data-mp="18cx3qe7qihvc">
            
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2903" data-mp="1hdl9klmz5bx5" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-2904" data-mp="2oqx23kqxlzgh">
            <div className="bg-accent-100 text-accent-600 p-3 rounded-2xl" data-id="element-2905" data-mp="2oqdky693vf3i">
              <FileText className="w-8 h-8" data-id="element-2906" data-mp="2sqxhb7luueol" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-2907" data-mp="nwterjkoerb7">
              Terms of Service
            </h1>
          </div>
          <p className="text-slate-500 text-sm" data-id="element-2908" data-mp="iyrxn46t922d">Last updated: April 7, 2025</p>
        </header>

        <div className="space-y-10 text-slate-700 leading-relaxed" data-id="element-2909" data-mp="dxaybd3z5nnw">
          <section data-id="element-2910" data-mp="9y23s6141lra">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2911" data-mp="9wiqmoar3qtq">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-2912" data-mp="50adfgg467p7">
              By downloading, installing, or using the IntelliEats mobile
              application ("App"), you agree to be bound by these Terms of
              Service ("Terms"). If you do not agree to these Terms, please do
              not use the App.
            </p>
          </section>

          <section data-id="element-2913" data-mp="3mcuou4d9grz9">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2914" data-mp="3icu98gefeaqm">
              2. Description of Service
            </h2>
            <p data-id="element-2915" data-mp="3df260q8bz274">
              IntelliEats is a mobile application that uses AI technology to
              scan and analyze ingredient labels on packaged food products. The
              App categorizes ingredients into "Safe," "Limited Intake," and
              "Ingredients to Avoid" based on available nutritional research and
              databases.
            </p>
          </section>

          <section data-id="element-2916" data-mp="2yqiopiy3td0v">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2917" data-mp="2ys3iv7giaty7">
              3. Disclaimer
            </h2>
            <div className="bg-accent-50 rounded-2xl p-6 border border-accent-100" data-id="element-2918" data-mp="3mhodwopxphnu">
              <p className="m-0 font-medium text-slate-800" data-id="element-2919" data-mp="3reob0a4t3a2t">
                <strong data-id="element-2920" data-mp="3crlbjxwxarcu">Important:</strong> IntelliEats is designed for
                informational purposes only and should not be considered medical
                or nutritional advice. The ingredient analysis provided by the
                App is based on general nutritional guidelines and may not
                account for individual health conditions, allergies, or dietary
                needs. Always consult with a qualified healthcare professional
                before making significant dietary changes.
              </p>
            </div>
          </section>

          <section data-id="element-2921" data-mp="1tqkn8nqg9qfm">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2922" data-mp="27kboz9xxw60s">
              4. User Responsibilities
            </h2>
            <ul className="space-y-3 list-none p-0" data-id="element-2923" data-mp="23j9okpsadnx8">
              <li className="flex items-start gap-3" data-id="element-2924" data-mp="1fsmdjvn2qi6g">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-2925" data-mp="1ftfdacnm87f3"></span>
                <span data-id="element-2926" data-mp="1auksj56388sc">
                  You are responsible for ensuring the accuracy of scanned
                  images and labels
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2927" data-mp="1jtprudph465k">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-2928" data-mp="1jwc06fk6upou"></span>
                <span data-id="element-2929" data-mp="306mosidq22wj">
                  You agree not to use the App for any unlawful purpose
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2930" data-mp="3qjks8wti4d2g">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-2931" data-mp="3ql47ql7c2k36"></span>
                <span data-id="element-2932" data-mp="3vjfhyx1jiwlx">
                  You acknowledge that scan results depend on image quality and
                  label clarity
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2933" data-mp="9bpm7eqn35pw">
                <span className="w-2 h-2 bg-accent-500 rounded-full mt-2 shrink-0" data-id="element-2934" data-mp="99cyeky7a14x"></span>
                <span data-id="element-2935" data-mp="dcretcq1wjiw">
                  You agree not to reverse engineer, decompile, or disassemble
                  the App
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-2936" data-mp="n4xdt6eq017l">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2937" data-mp="s1xipdzu2xx4">
              5. Intellectual Property
            </h2>
            <p data-id="element-2938" data-mp="x1teipydnj1l">
              All content, features, and functionality of the App—including but
              not limited to text, graphics, logos, icons, and software—are the
              exclusive property of IntelliEats and are protected by
              international copyright, trademark, and other intellectual
              property laws.
            </p>
          </section>

          <section data-id="element-2939" data-mp="2cjpw9jcs0xe8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2940" data-mp="2cj6imeu5sv60">
              6. Limitation of Liability
            </h2>
            <p data-id="element-2941" data-mp="27mg2jrictzkl">
              To the fullest extent permitted by applicable law, IntelliEats and
              its developer shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages arising out of or
              related to your use of the App. This includes, but is not limited
              to, any health-related decisions made based on the App's analysis.
            </p>
          </section>

          <section data-id="element-2942" data-mp="3nyv4f2vofo58">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2943" data-mp="3nzejmbtxzyfk">
              7. Pricing
            </h2>
            <p data-id="element-2944" data-mp="3j7dc137pyvvv">
              The ingredient scanning feature of IntelliEats is free to use.
              Customization features may be available at a minimum cost. We
              reserve the right to modify pricing with reasonable notice to
              users.
            </p>
          </section>

          <section data-id="element-2945" data-mp="17k9vbwytib6p">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2946" data-mp="17kt2qjqudh6h">
              8. Termination
            </h2>
            <p data-id="element-2947" data-mp="1ci1kwkbzpl7q">
              We reserve the right to terminate or suspend your access to the
              App at any time, without prior notice, for conduct that we believe
              violates these Terms or is harmful to other users, us, or third
              parties.
            </p>
          </section>

          <section data-id="element-2948" data-mp="tla6opbb1waj">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2949" data-mp="tks0p0yuc3pf">
              9. Changes to Terms
            </h2>
            <p data-id="element-2950" data-mp="2j19lalxp0dxk">
              We reserve the right to modify these Terms at any time. Continued
              use of the App after changes constitutes acceptance of the revised
              Terms.
            </p>
          </section>

          <section className="bg-brand-50 rounded-2xl p-8 border border-brand-100" data-id="element-2951" data-mp="2y3hr43s9b72x">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2952" data-mp="2t5q0dd3clr0b">
              10. Contact Us
            </h2>
            <p className="mb-4" data-id="element-2953" data-mp="36wuvq2zonx4u">
              If you have any questions about these Terms, please contact us:
            </p>
            <p className="font-medium text-slate-900" data-id="element-2954" data-mp="3gtr325duid7t">
              Email:{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 transition-colors" data-id="element-2955" data-mp="3gvu0hahbv8mk">
                
                intellieats@gmail.com
              </a>
            </p>
            <p className="mt-2" data-id="element-2956" data-mp="3ps30aq97w998">
              Or use our{' '}
              <Link to="/contact" className="text-brand-600 hover:text-brand-700 font-medium transition-colors" data-id="element-2957" data-mp="3ltc4cmghmxnp">
                
                Contact Support
              </Link>{' '}
              page.
            </p>
          </section>
        </div>
      </div>
    </motion.div>;
}